module.exports = {"230227100":"富裕镇","230227101":"富路镇","230227102":"富海镇","230227103":"二道湾镇","230227104":"龙安桥镇","230227105":"塔哈镇","230227200":"繁荣乡","230227201":"绍文乡","230227202":"忠厚乡","230227203":"友谊乡","230227500":"富裕牧场","230227501":"繁荣种畜场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230227.json
// module id = 644
// module chunks = 0